
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class Menu extends Vue {
  async exportPayment() {
    const historyExport: any = await (this.$root as any)._post(
      "claims/exportpaymentsxls",
      {}
    );
    if (historyExport.path) {
      window.open(historyExport.path);
    }
  }
}
